import { render, staticRenderFns } from "./settingIndex.vue?vue&type=template&id=29ce574f&scoped=true"
import script from "./settingIndex.vue?vue&type=script&lang=js"
export * from "./settingIndex.vue?vue&type=script&lang=js"
import style0 from "./settingIndex.vue?vue&type=style&index=0&id=29ce574f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ce574f",
  null
  
)

export default component.exports